/**
 * Whose settings this browser's cache holds: one verified address.
 *
 * **This is the sixth module allowed to touch `localStorage`.** The four
 * settings caches cannot say whose they are, and the settings sync needs to
 * know (ADR-0014). A browser whose cache belongs to one employee must not upload
 * it into a second employee's document when the second one signs in there.
 * An address is not a credential, so this widens ADR-0003's exemption to a
 * named file, as the other five do.
 *
 * `.oxlintrc.json` exempts this file for `localStorage` and nothing else, the
 * same narrowing the others get.
 *
 * No entry point throws. A browser that stores nothing reads as holding a cache
 * with no owner, which the sync treats as the signed-in employee's own.
 */

/** The only key this module writes. */
export const PREFERENCE_OWNER_KEY = 'ui-internal.preferences-owner'

/**
 * The address whose settings this browser caches.
 *
 * @returns The address, or null when no signed-in load has recorded one.
 */
export function readPreferenceOwner(): string | null {
  try {
    return localStorage.getItem(PREFERENCE_OWNER_KEY)
  } catch {
    return null
  }
}

/**
 * Record whose settings this browser now caches.
 *
 * @param viewer - The signed-in address.
 */
export function writePreferenceOwner(viewer: string): void {
  try {
    localStorage.setItem(PREFERENCE_OWNER_KEY, viewer)
  } catch {
    // Storage disabled. Nothing is cached either, so there is nothing to own.
  }
}
